import Axios from '@/axios';

// 访客人员列表查询
export const getVisitorRecords = params => {
  return Axios({
    url: '/face/web/visit/index_visitor',
    method: 'GET',
    type: 'json',
    params
  })
}
// 根据预约申请id查询访客申请列表
export const getVisitorApplyByAppointmentId = params => {
  return Axios({
    url: '/face/web/visit/list_visit_apply_by_appointment/' + params.id,
    method: 'GET',
    type: 'json',
    params
  })
}
// 访客申请详情
export const getVisitorApplyDetail = params => {
  return Axios({
    url: '/face/web/visit/show_visit_apply/' + params.id,
    method: 'GET',
    type: 'json',
    params
  })
}

// 新增黑名单人员
export const exportVisitorSearchList = data => {
  return Axios({
    url: '/face/web/visit/export_visitor',
    method: 'POST',
    type: 'json',
    data
  })
}
